module.exports = __webpack_public_path__ + "img/scancodes.76a7826a.png";